import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { IConfig } from 'ngx-mask';
import { BasicRegister } from "../../../models/basic-register.model";
import { MgService } from "../../../services/mg.service";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-business-selection',
  templateUrl: './business-selection.component.html',
  styleUrls: ['./business-selection.component.scss']
})
export class BusinessSelectionComponent implements OnInit {
  @Output()
  businessSelected: EventEmitter<BasicRegister> = new EventEmitter<BasicRegister>()

  public callForm: UntypedFormGroup;
  public items: BasicRegister[] = [];
  public displayedColumns: string[] = ['id', 'name', 'cnpj', 'options'];
  public modelChanged: Subject<string> = new Subject<string>();
  public search: string = '';

  constructor(
    private fb: UntypedFormBuilder,
    public http: MgService,
  ) {
    this.modelChanged.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(
        model => {
          this.search = model
          this.searchBusiness();
        }
      )
  }

  ngOnInit(): void {
    this.callForm = this.fb.group({
      search: ['', [Validators.required]]
    });
  }

  public maskConfig: () => Partial<IConfig> = () => {
    return {
      validation: false,
    };
  }

  public selectBusinessFromSearch(value: BasicRegister) {
    this.items = []
    this.businessSelected.emit(value);
  }

  public searchItems(value: string){
    this.modelChanged.next(value);
  }

  public searchBusiness(){
    if (this.callForm.value.search == "") {
      this.items = []
      return
    }

    this.http.searchBusiness(this.callForm.value.search)
      .subscribe(
        res => {
          this.items = res.data
        },
        err => console.error(err)
      )
  }

  public changeBusiness() {
    this.callForm.get('search').setValue('');
    this.businessSelected.emit(null)
  }
}
